//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import isEmpty from "lodash/isEmpty";
import TheDatePicker from "../TheDatePicker.vue";
import ObjectSelectSearchable from "@/components/objects/ObjectSelectSearchable.vue";

export default {
  name: "EditCharacteristics",
  components: {
    ObjectSelectSearchable,
    TheDatePicker,
  },
  props: {
    object_type: {
      type: [Object, String]
    },
    visible: {
      type: Boolean,
      default: false
    },
    properties: {
      type: Array
    },
    form: {
      type: Object
    },
    index: {
      type: String
    },
    inRangeRules: {
      type: Number, // 0 - никаких требований, 1 // обязательно рейнж, 2 // только число
      default: 0
    },
    isArt: {
      type: Boolean,
      default: false
    },
  },
  data() {
    const typeValidator = function (rule, value, callback) {
      if (!this.computedTypeValue) callback(new Error('Необходимо заполнить'))
      callback();
    }.bind(this)

    const templateValidator = function (rule, value, callback) {
      if (this.allowSaveType) {
        return callback()
      }
      if (!this.addPropertySelect) callback(new Error('Необходимо заполнить'))
      callback();
    }.bind(this)

    const valueValidator = function (rule, value, callback) {
      if (this.computedProperty.template.value.type === 'number') {
        if (this.numberIsRange) {
          if (this.computedProperty.value[1] <= this.computedProperty.value[0] && this.computedProperty.value[1] !== null) {
            return callback('Неверный диапазон')
          }
        }

        if (this.computedProperty.value[0] === null) {
          return callback('Поле обязательно для заполнения')
        }
      }

      if (this.computedProperty.template.value.type === 'date') {
        const error = this.$refs.datepicker.checkValidate()[0]
        if (error === false) {
          const dates = this.$refs.datepicker.save()
          this.computedProperty.date = {
            vfrom: dates.event_from.value,
            vfrom_approx: dates.event_from.is_approx,
            vto: dates.event_to.value,
            vto_approx: dates.event_to.is_approx,
          }
          return callback()
        } else {
          callback(error)
        }
      }

      if (this.computedProperty.template.value.type === 'object') {
        let missmatchObjects = []
        if (this.computedProperty.template.value.objects_types.length && this.computedProperty.value?.length) {
          this.computedProperty.value.forEach(key => {
            const obj = this.$store.getters["objects/cachedObjectsGetter"].find(x => x.key === key)
            const objTypeId = obj?.raw?.type?.id
            if (objTypeId && !this.computedProperty.template.value.objects_types.includes(objTypeId)) {
              missmatchObjects.push(obj.short_label || obj.label)
            }
          })
        }
        if (missmatchObjects.length) {
          return callback(new Error(`Объект(ы): ${missmatchObjects.map(x => `"${x}"`).join(',')} не подходят под ограничение характеристики`))
        }
      }

      if (this.computedProperty.template.value.type === 'plain') {
        if (this.computedProperty.value.length > 100) {
          return callback(new Error('Не более 100 символов'))
        }
      }

      if (
        !this.computedProperty?.value ||
        (Array.isArray(this.computedProperty?.value) && !this.computedProperty.value.length)
      ) {
        return callback(new Error('Необходимо заполнить'))
      }
      callback();
    }.bind(this)

    return {
      objectTypes: [],
      propertiesTemplates: [],
      propertiesToDelete: [],
      addPropertySelect: undefined,
      ready: false,
      state: null,
      stateType: undefined,
      ruleForm: {
        type: '',
        template: '',
        value: '',
      },
      rules: {
        type: [{ trigger: 'change', validator: typeValidator }],
        value: [{ trigger: ['change', 'blur'], validator: valueValidator }],
        template: [{ trigger: 'change', validator: templateValidator }]
      },
      fake: {},
      numberIsRange: false,
      objectForSelect: []
    }
  },
  computed: {
    siTypes() {
      return this.$store.state.property_templates.consts.si.map(item => {
        return {
          value: item.id,
          id: item.id,
          label: `${item.name} (${item.si})`,
          data: item,
        }
      })
    },
    computedTypeValue: {
      get() {
        if (typeof this.type === 'object' && !Object.keys(this.type).length) return ""
        return this.type
      },
      set(newValue) {
        this.type = newValue
      },
    },
    availableProperties() {
      return this.propertiesTemplates
        .filter(template => this.addedProperties.findIndex(x => x.template.id === template.id) < 0)
        .map(x => {
          const result = {
            id: x.id,
            label: x.label
          }

          if (x.value && x.value.type === 'number' && x.value_si) {
            if (this.siTypes.find(type => type.value === x.value_si)) {
              result.label = `${result.label} (${this.siTypes.find(type => type.value === x.value_si)?.label})`
            }
          }

          return result
        })
    },
    computedProperty: {
      get() {
        return this.state ? this.state : this.form
      },
      set(newValue) {
        this.state = newValue
      },
    },
    isNewProp() {
      return this.form === undefined || this.form === null
    },
    addedProperties() {
      return [...this.properties.filter(x => !x.is_deleted)]
    },
    type: {
      get() {
        return this.stateType
      },
      set(newValue) {
        this.stateType = newValue;
      }
    },
    siGroup() {
      if (!this.computedProperty?.template?.value_si) return ""
      return this.siTypes.find(x => x.value === this.computedProperty.template.value_si)?.data?.group
    },
    allowResetType() {
      return this.addedProperties.length === 0
    },
    allowSaveType() {
      return this.allowResetType && !isEmpty(this.type) && !this.addPropertySelect
    },
    humanReadableTypeSelected() {
      return isEmpty(this.type) ? '' : `Выбран тип: ${this.type.label}`
    },
    computedOptionsList() {
      if (!this.computedProperty.template?.value?.options) return []
      return this.computedProperty.template.value.options.map((x, index) => {
        return {
          label: x.value,
          id: x.key,
          divider: Boolean(x.divider),
          index: index
        }
      })
    }
  },
  watch: {
    'visible': function (val) {
      if (val && this.object_type) {
        this.stateType = this.object_type
        this.ready = false

        this.fetchPropTemplates().then(async () => {
          this.ready = true

          if (this.computedProperty && this.computedProperty.template.value.type === 'number') {
            if (this.computedProperty.value[0] !== this.computedProperty.value[1] || this.inRangeRules === 1) {
              this.numberIsRange = true
            }
          }

          if (this.computedProperty && !this.computedProperty.value_si) {
            this.computedProperty.value_si = this.computedProperty.template.value_si
          }

          if (this.computedProperty && this.computedProperty.template.value.type === 'select' && !this.computedProperty.template.value.many) {
            this.computedProperty.value = this.computedProperty.value[0]
          }

          if (this.computedProperty && this.computedProperty.template.value.type === 'object') {
            this.objectForSelect = await this.fetchObjectsForSelect(this.computedProperty.template.value.objects)
          }
        })

      } else {
        this.ready = true
        this.numberIsRange = false
      }
    }
  },
  methods: {
    handleChangeType(value) {
      this.propertiesTemplates = []
      this.computedTypeValue = value;
      this.fetchPropTemplates();
    },
    fetchPropTemplates: async function () {
      const response = await this.$store.dispatch('property_templates/fetchObjects', {
        types: this.computedTypeValue.id || this.computedTypeValue.key
      })

      this.propertiesTemplates = response.items

      return response
    },
    fetchObjectTypes: function (val) {
      return this.$store.dispatch('objects_types/fetchObjects', { q: val, kind: this.isArt ? 'art' : 'enc' }).then(({ items, total }) => {
        this.objectTypes = items.map(x => {
          return { key: x.id, label: x.label, id: x.id }
        })

        return { items: this.objectTypes, total: total }
      })
    },
    handleAddProperty(val) {
      const template = this.findPropertyTemplate(val);
      let initialValue = ''

      if (template.value.type === 'select' && template.value.many) {
        initialValue = []
      } else if (template.value.type === 'number') {
        initialValue = [null, null]
      } else if (template.value.type === 'object') {
        initialValue = undefined
      }

      this.state = {
        template: template,
        value: initialValue,
        value_si: template.value_si
      }
    },
    findPropertyTemplate(id) {
      return this.propertiesTemplates.find(x => x.id === id);
    },
    reset() {
      this.$nextTick(() => {
        this.state = null;
        this.addPropertySelect = undefined;
        this.stateType = undefined;
        this.propertiesTemplates = []
        this.objectTypes = []
      })
    },
    resetType() {
      this.$emit('reset')
      this.reset()
    },
    saveOnlyType() {
      this.$emit('save-type', {
        type: {
          id: this.type.id,
          label: this.type.label
        },
        templates: this.propertiesTemplates
      })
      this.reset()
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          // Когда свойств нет (или все удалены), сохраняем только выбранный тип.
          if (!this.computedProperty) {
            if (!isEmpty(this.type)) {
              this.saveOnlyType()
            }
            return
          }

          if (this.allowSaveType) {
            this.saveOnlyType()
            return
          }
          const payload = {
            type: this.type,
            property: this.computedProperty,
            index: this.index,
            added: this.isNewProp,
            templates: this.propertiesTemplates
          }

          if (this.computedProperty.date_from) {
            Object.assign(payload, {
              vfrom: this.computedProperty.date_from.value,
              vfrom_approx: this.computedProperty.date_from.is_approx,
            })
            delete this.computedProperty.date_from
          }

          if (this.computedProperty.date_to) {
            Object.assign(payload, {
              vto: this.computedProperty.date_to.value,
              vto_approx: this.computedProperty.date_to.is_approx,
            })
            delete this.computedProperty.date_to
          }

          if (payload.property.template.value.type === 'number') {
            if (!this.numberIsRange || (this.numberIsRange && payload.property.value[1] === null)) {
              payload.property.value[1] = payload.property.value[0]
            }

            // установка корректного из формы SI, поскольку от бэка еще нет вычисленного значения
            // хак только для отображения единицы в при создании новых характеристик
            if (payload.property.template.value_si && payload.property.value_si) {
              payload.property.value_si_info = { ...this.siTypes.find(x => x.value === payload.property.value_si).data }
            }
          }

          // Преобразование одиночного значения селекта к списку
          if (payload.property.template.value.type === 'select' && !payload.property.template.value.many) {
            payload.property.value = [payload.property.value]
          }

          this.$emit('save', payload)
          this.reset()
        }
      })
    },
    cancel() {
      this.$emit('cancel')
      this.reset()
    },
    addOptionToList(val) {
      this.$store.dispatch('property_templates/addListItem', {
        template_id: this.computedProperty.template.id,
        item: val
      })
        .then(r => {
          this.propertiesTemplates = this.propertiesTemplates.map(x => {
            return r.data.id === x.id ? r.data : x
          })
          const valId = r.data.value.options.find(x => x.value === val).key

          Object.assign(this.computedProperty, {
            template: r.data
          })
          Object.assign(this.computedProperty, {
            value: Array.isArray(this.computedProperty.value) ? [...this.computedProperty.value, valId] : valId
          })
        })
    },
    handleChangeNumber(val, index) {
      let value = [...this.computedProperty.value]
      value[index] = val
      this.computedProperty = {
        ...this.computedProperty,
        value: value
      }
    },
    fetchObjectsForSelect(ids = []) {
      return this.$store.dispatch('objects/publicSearch', {
        ids: ids.join(','),
        limit: ids.length
      }).then(items => {
        return items.map(item => {
          return {
            label: item.label,
            key: item.id,
            raw: item
          }
        })
      })
    }
  }
}
